import React, { useState } from 'react'
import { IconButton, InputAdornment, TextField } from '@mui/material'
import { color } from '@trivie/ui-web/theme'
import { Delete, SwapHoriz } from '@mui/icons-material'
import { observer } from 'mobx-react-lite'

export const ChoicePair = observer((props: any) => {
  const { question, left, pair, index } = props

  const [hovered, setHovered] = useState<any>()

  const textSx = {
    '& .MuiInputBase-root': {
      textDecoration: 'none',
      fontSize: 14,
      fontFamily: 'Inter',
      fontWeight: 500,
      paddingRight: '20px',
      lineHeight: '16.94px',
      paddingTop: '8px',
      paddingBottom: '8px',
      pointerEvents: 'auto',
      paddingLeft: '20px',
    },
  }

  const handleBackspace = (e) => {
    if (
      question?.choices[0].pairs?.length > 2 &&
      pair.left === '' &&
      pair.right === '' &&
      e.key === 'Backspace'
    ) {
      pair.delete()
    }
  }

  return (
    <div style={PAIR_CONTAINER}>
      <TextField
        multiline
        sx={{
          ...textSx,
          '& .MuiInput-underline:after': {
            borderBottomColor: pair.touched && pair.formErrors.left ? color.red : color.blue,
          },
          '& .MuiInput-underline:before': {
            borderBottomColor:
              pair.touched && pair.formErrors.left && !question?.generatingAll
                ? color.red
                : color.shade10,
          },
        }}
        style={{ width: '100%' }}
        value={pair?.left}
        variant="standard"
        placeholder={`Choice ${index + 1}`}
        inputProps={{ 'aria-label': 'Choice 1' }}
        onChange={(e) => pair.setLeft(String(e.target.value))}
        onKeyDown={handleBackspace}
      />
      <SwapHoriz htmlColor={color.shade50} fontSize="large" />
      <TextField
        onMouseEnter={() => setHovered(pair)}
        onMouseLeave={() => setHovered(null)}
        sx={{
          '& .MuiInputBase-root': { ...textSx['& .MuiInputBase-root'], paddingRight: '44px' },
          '& .MuiInput-underline:after': {
            borderBottomColor: pair.touched && pair.formErrors.right ? color.red : color.blue,
          },
          '& .MuiInput-underline:before': {
            borderBottomColor:
              pair.touched && pair.formErrors.right && !question?.generatingAll
                ? color.red
                : color.shade10,
          },
        }}
        style={{ width: '100%' }}
        value={pair?.right}
        variant="standard"
        placeholder={`Match ${index + 1}`}
        inputProps={{ 'aria-label': 'Match 1' }}
        multiline
        onChange={(e) => pair.setRight(String(e.target.value))}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end" style={{ position: 'absolute', right: 0 }}>
              <div style={{ flexDirection: 'row', cursor: 'pointer' }}>
                {question?.choices[0].pairs.length > 2 && hovered === pair && (
                  <IconButton
                    sx={{
                      '&:hover': {
                        svg: { color: color.shade50, transition: 'color .5s' },
                      },
                    }}
                    style={{ marginRight: 2 }}
                    onClick={pair.delete}
                  >
                    <Delete style={{ fontSize: 18 }} htmlColor={color.shade30} />
                  </IconButton>
                )}
              </div>
            </InputAdornment>
          ),
        }}
      />
    </div>
  )
})

const PAIR_CONTAINER: React.CSSProperties = {
  alignItems: 'center',
  gap: 12,
  display: 'flex',
  flexDirection: 'row',
}
